import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AudienceProvider } from "./context/AudienceContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

import Home from "./pages/Home";
import Konzepte from "./pages/Konzepte";
import Stilserien from "./pages/Stilserien";
import Refit from "./pages/Refit";
import Individualisierung from "./pages/Individualisierung";
import Konfigurator from "./pages/Konfigurator";
import Shop from "./pages/Shop";
import ShopDetail from "./pages/ShopDetail";
import Gewerblich from "./pages/Gewerblich";
import Broschuere from "./pages/Broschuere";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import UeberUns from "./pages/UeberUns";
import MobileStickyCTA from "./components/MobileStickyCTA";
import Nora from "./components/Nora";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/konzepte" element={<Konzepte />} />
          <Route path="/stilserien" element={<Stilserien />} />
          <Route path="/stilserien/:slug" element={<Stilserien />} />
          <Route path="/refit" element={<Refit />} />
          <Route path="/individualisierung" element={<Individualisierung />} />
          <Route path="/konfigurator" element={<Konfigurator />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:slug" element={<ShopDetail />} />
          <Route path="/gewerblich" element={<Gewerblich />} />
          <Route path="/broschuere" element={<Broschuere />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <MobileStickyCTA />
      <Nora />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <AudienceProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Shell />
          <Toaster position="bottom-right" />
        </BrowserRouter>
      </AudienceProvider>
    </div>
  );
}
